import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

export const getCountryCode = (phone: string): ECountryCode => {
    const parsed = parsePhoneNumberFromString(phone);

    if (!parsed) return ECountryCode.Mexico;

    return `+${parsed.countryCallingCode}` as ECountryCode;
};
